import styled from "styled-components";
import { DEFAULT_FONT_FAMILY } from "common/constants";

interface IStyleProps {
  topValue?: number;
  leftValue?: number;
  widthValue?: number;
  heightValue?: number;
  diameterValue?: number;
  cursorValue?: string;
  isDisabled?: boolean;
  colorValue?: string;
}

export const Root = styled.div`
  display: flex;
  align-items: center;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2d3548;
`;

export const Label = styled.div`
  padding-right: 10px;
`;

export const SliderContainer = styled.div`
  width: ${(props: IStyleProps) => (props.widthValue ?? 84)}px;
  display: flex;
  align-items: center;
  position: relative;
  padding: ${(props: IStyleProps) => (props.diameterValue ? props.diameterValue / 2 : 5)}px 0px;
`;

export const Sphere = styled.input`
  padding: 5px 0px;
  cursor: ${(props: IStyleProps) => (props.cursorValue ?? `auto`)};
  &::-webkit-slider-runnable-track {
    height: ${(props: IStyleProps) => (props.heightValue ?? 1)}px;
    background-color: ${(props: IStyleProps) => (props.colorValue ?? "#a5a5a5")};
  }
  &::-moz-range-track {
    height: ${(props: IStyleProps) => (props.heightValue ?? 1)}px;
    background-color: ${(props: IStyleProps) => (props.colorValue ?? "#a5a5a5")};
  }
  &::-webkit-slider-thumb {
    margin-top: -${(props: IStyleProps) => ((props.diameterValue ? props.diameterValue / 2 : 4) - 0.5)}px;
    width: ${(props: IStyleProps) => (props.diameterValue ?? 8)}px;
    height: ${(props: IStyleProps) => (props.diameterValue ?? 8)}px;
    background-color: ${(props: IStyleProps) => (props.colorValue ?? "#a5a5a5")};
    border-radius: 50%;
    transition: transform 0.4s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  &:hover::-webkit-slider-thumb {
    transform: scale(${(props: IStyleProps) => (props.isDisabled ? 1 : 1.5)});
  }
  &::-moz-range-thumb {
    margin-top: -${(props: IStyleProps) => ((props.diameterValue ? props.diameterValue / 2 : 4) - 0.5)}px;
    width: ${(props: IStyleProps) => (props.diameterValue ?? 8)}px;
    height: ${(props: IStyleProps) => (props.diameterValue ?? 8)}px;
    background-color: ${(props: IStyleProps) => (props.colorValue ?? "#a5a5a5")};
    border-color: ${(props: IStyleProps) => (props.colorValue ?? "#a5a5a5")};
    border-radius: 50%;
    transition: transform 0.4s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  &:hover::-moz-range-thumb {
    transform: scale(${(props: IStyleProps) => (props.isDisabled ? 1 : 1.5)});
  }
`;

export const Seconds = styled.div`
  position: absolute;
  width: 32px;
  top: 18px;
  font-size: 10px;
  text-align: center;
  left: ${(props: IStyleProps) => (props.leftValue ?? 0)}px;
  color: ${(props: IStyleProps) => (props.colorValue ?? "#a5a5a5")};
`;